import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const StreetView = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='StreetView' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16,5 C16,7.209 14.209,9 12,9 C9.791,9 8,7.209 8,5 C8,2.791 9.791,1 12,1 C14.209,1 16,2.791 16,5 L16,5 Z M15,23 L15,17 L18,17 L18,15 C18,11.66 15.24,9.03 12,9 C8.79,9.03 6,11.66 6,15 L6,17 L9,17 L9,23 M3.5,23 L20.5,23 L3.5,23 Z' />
  </StyledIcon>
);
